import { render, staticRenderFns } from "./lifecycle.vue?vue&type=template&id=390a159d&scoped=true&"
import script from "./lifecycle.vue?vue&type=script&lang=js&"
export * from "./lifecycle.vue?vue&type=script&lang=js&"
import style0 from "./lifecycle.vue?vue&type=style&index=0&id=390a159d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a159d",
  null
  
)

export default component.exports